export default String.raw`
{% assign cpId = cart.SelectedDelivery.CollectionPointTypeId | ToInt -%}
{% if cpId == 1 or cpId > 999 -%}
    {% assign goodType = true -%}
{% endif -%}
{% if cart.SelectedDelivery.CollectionPoint -%}
    <div class="cart-collection-point collection-point-info-js">
        <p>
            {% if cart.SelectedDelivery.CollectionPointTypeId == 2 -%}
                {{ translations.ChoosenInpostMachine }}:
            {% else -%}
                {{ translations.ChoosenCollectionPoint }}:
            {% endif -%}
        </p>
        <div class="cart-collection-point__content">
            {% assign cp = cart.SelectedDelivery.CollectionPoint -%}
            {% assign name = cp.Address | Split:',' | Last | Split:'(' | First -%}
            {% if name == '' or name == ' ' or name == '  ' -%}
                {% assign name = cp.Address | Split:'(' | Last | Remove:')' -%}
                {% capture name -%}{{name}}{% endcapture -%}
            {% endif -%}
            <p><strong>{{name}}</strong></p>
            <p>{{cp.Street}} {{cp.StreetNo}}{% if cp.UnitNo != null and cp.UnitNo != '' -%}/{{cp.UnitNo}}{% endif -%}</p>
            <p>{{cp.ZipCode}} {{cp.City}}</p>
            <p>{{cp.Country}}</p>
            {% if goodType -%}
                {% if cp.OpeningHoursMonFri != null or cp.OpeningHoursSat != null or cp.OpeningHoursSun != null -%}
                    <p><strong>{{translations.OpenHours}}</strong></p>
                    {% if cp.OpeningHoursMonFri != null -%}
                        <p><span style="display: inline-block; width: 70px">{{translations.MondayFriday}}:</span> {{cp.OpeningHoursMonFri}}</p>
                    {% endif -%}
                    {% if cp.OpeningHoursSat != null -%}
                        <p><span style="display: inline-block; width: 70px">{{translations.Saturday}}:</span> {{cp.OpeningHoursSat}}</p>
                    {% endif -%}
                    {% if cp.OpeningHoursSun != null -%}
                        <p><span style="display: inline-block; width: 70px">{{translations.Sunday}}:</span> {{cp.OpeningHoursSun}}</p>
                    {% endif -%}
                {% endif -%}
            {% endif -%}
        </div>
        <button class="cart__action-btn cart-collection-point__btn show-map-in-order-js">
            {{translations.Change}}
        </button>
    </div>
{% endif -%}
{% assign list = false -%}
{% if goodType -%}
    {% if settings.POOType == 'list' or settings.googleMapsKey == '' or cart.SelectedDelivery.CollectionPointMapUrl == null -%}
        {% assign list = true -%}
    {% endif -%}
{% endif -%}
<div class="cart-collection-point map-container-in-order-js {% if cart.SelectedDelivery.CollectionPoint -%} hidden-js collection-point-selected-js {% endif -%}">
    <div class="cart-collection-point collection-points-js collection-points-box {% if list == false -%} hidden-js {% endif -%}" data-type-id="{{cart.SelectedDelivery.CollectionPointTypeId}}">
        <div>{{ translations.ChooseCollectionPoint }}</div>
        <ul class="cart-collection-point__content collection-points-list-js" data-selected-point-id="{{cart.SelectedDelivery.CollectionPoint.Id}}"></ul>
    </div>
    <button id="ifMapContainer" class="cart__action-btn choose-collection-point-button-js {% if list -%} hidden-js {% endif -%}"
            data-typeid="{{ cart.SelectedDelivery.CollectionPointTypeId }}"
            data-mapkey="{{ settings.googleMapsKey }}"
            data-country="{{ cart.Customer.DeliveryAddress.Country }}"
            data-city="{{ cart.Customer.DeliveryAddress.City | H }}"
            data-zipcode="{{ cart.Customer.DeliveryAddress.ZipCode | H }}"
            data-cod="{% if cart.SelectedDelivery.Payment.COD -%}true{% else -%}false{% endif -%}"
            data-pointdata="{{ cart.SelectedDelivery.CollectionPointMapData | H }}"
            data-street="{{ cart.Customer.DeliveryAddress.Street | H }}"
            data-mapurl="{{ cart.SelectedDelivery.CollectionPointMapUrl }}"
            data-pointId="{{ cart.SelectedDelivery.CollectionPoint.Id | H }}">
        {% if cart.SelectedDelivery.CollectionPointTypeId == 2 -%}
            {{ translations.ChooseInpostMachine }}
        {% else -%}
            {{ translations.ChooseCollectionPoint }}
        {% endif -%}
    </button>
</div>

{% if cart.Changes == null and cart.SelectedDelivery.CollectionPoint == null -%}
    <script>$(function(){__pp.openMap();});</script>
{% endif -%}

`